module.exports = __webpack_public_path__ + "static/media/floating_heart_purple7baf18369d8f17208082feac940f54e8.gif";